import * as React from 'react';
import { Responsive, uaToDeviceType, UiKitRoot } from '@cian/ui-kit';
import { DesktopViewContainer, MobileViewContainer } from '../Views';
import { useSelector } from 'react-redux';
import { DesktopSimpleViewContainer } from '../Views/DesktopSimpleView';
import { MobileSimpleViewContainer } from '../Views/MobileSimpleView';
import { selectIsMyHomePage } from '../../selectors/myHome/selectIsMyHomePage';

export interface IPageContainerProps {
  userAgent: string | null;
}

export const PageContainer: React.FC<IPageContainerProps> = ({ userAgent }) => {
  const deviceType = React.useMemo(() => uaToDeviceType(userAgent || undefined), [userAgent]);
  const isMyHomePage = useSelector(selectIsMyHomePage);

  // Для сервиса Мой Дом в Новостройке необходим Ход строительства без блоков застройщика и тд
  // Поэтому по query-парметру мы рисуем отдельный layout
  if (isMyHomePage) {
    return (
      <UiKitRoot deviceType={deviceType}>
        <Responsive phone tablet>
          <MobileSimpleViewContainer />
        </Responsive>
        <Responsive desktop>
          <DesktopSimpleViewContainer />
        </Responsive>
      </UiKitRoot>
    );
  }

  return (
    <UiKitRoot deviceType={deviceType}>
      <Responsive phone tablet>
        <MobileViewContainer />
      </Responsive>
      <Responsive desktop>
        <DesktopViewContainer />
      </Responsive>
    </UiKitRoot>
  );
};
